import { render } from "./TeacherListTable.vue?vue&type=template&id=50ce38de&scoped=true&ts=true"
import script from "./TeacherListTable.vue?vue&type=script&lang=ts"
export * from "./TeacherListTable.vue?vue&type=script&lang=ts"

import "./TeacherListTable.vue?vue&type=style&index=0&id=50ce38de&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ce38de"]])

export default __exports__